<template>
<div class="FansIntegralMgt">
</div>
</template>

<script>
export default {
    name: 'FansIntegralMgt',
    data() {
        return {}
    },
    mounted() {
    },
    methods: {},
    filters: {},
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.FansIntegralMgt {
}
</style>
